import React, { useState } from 'react';
import { ArrowLeftIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FontTestPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <div className="w-full bg-white" data-id="element-1476">
      {/* Replica Font Styles */}
      <style data-id="element-1477">
        {`
          @import url('https://fonts.cdnfonts.com/css/replica-2');
          .replica-font {
            font-family: 'Replica', sans-serif;
          }
        `}
      </style>
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-1478">
        <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-1479">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-1480" />
          <span data-id="element-1481">Go Back</span>
        </Link>
      </div>
      {/* Header with Replica Font */}
      <header className="w-full bg-white py-4 px-6 md:px-12 border-b border-gray-100" data-id="element-1482">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-1483">
          <div className="flex items-center" data-id="element-1484">
            <a href="/" className="no-underline" data-id="element-1485">
              <img src="https://cdn.magicpatterns.com/uploads/8EVxVy8dkAVEdmFcPkswyr/Caveo_2026_Logo.png" alt="Caveo Logo" className="h-8 md:h-10" data-id="element-1486" />
            </a>
          </div>
          <nav className="hidden md:flex space-x-6" data-id="element-1487">
            <a href="/product" className="text-[#3d3d3d] no-underline hover:text-[#138091] replica-font" data-id="element-1488">
              Product
            </a>
            <a href="/about-us" className="text-[#3d3d3d] no-underline hover:text-[#138091] replica-font" data-id="element-1489">
              About Us
            </a>
            <a href="/resources" className="text-[#3d3d3d] no-underline hover:text-[#138091] replica-font" data-id="element-1490">
              Resources
            </a>
          </nav>
          <div className="hidden md:flex items-center space-x-4" data-id="element-1491">
            <a href="/login" className="text-[#3d3d3d] no-underline hover:text-[#138091] px-4 py-2 rounded-md replica-font" data-id="element-1492">
              Login
            </a>
            <a href="/signup" className="bg-[#138091] text-white px-4 py-2 rounded-md font-medium no-underline hover:bg-[#3ab0bb] transition-colors replica-font" data-id="element-1493">
              Start Now
            </a>
          </div>
          <div className="md:hidden" data-id="element-1494">
            <button onClick={toggleMenu} className="text-[#3d3d3d] focus:outline-none" data-id="element-1495">
              {isMenuOpen ? <XIcon size={24} data-id="element-1496" /> : <MenuIcon size={24} data-id="element-1497" />}
            </button>
          </div>
        </div>
        {/* Mobile menu */}
        {isMenuOpen && <div className="md:hidden fixed inset-0 z-50 bg-white pt-20 px-6" data-id="element-1498">
            <div className="flex flex-col space-y-4" data-id="element-1499">
              <a href="/product" className="text-[#3d3d3d] text-xl py-2 no-underline hover:text-[#138091] replica-font" onClick={toggleMenu} data-id="element-1500">
                Product
              </a>
              <a href="/about-us" className="text-[#3d3d3d] text-xl py-2 no-underline hover:text-[#138091] replica-font" onClick={toggleMenu} data-id="element-1501">
                About Us
              </a>
              <a href="/resources" className="text-[#3d3d3d] text-xl py-2 no-underline hover:text-[#138091] replica-font" onClick={toggleMenu} data-id="element-1502">
                Resources
              </a>
              <div className="pt-4 flex flex-col space-y-4" data-id="element-1503">
                <a href="/login" className="text-[#3d3d3d] text-center py-2 border border-gray-200 rounded-md no-underline hover:text-[#138091] replica-font" onClick={toggleMenu} data-id="element-1504">
                  Login
                </a>
                <a href="/signup" className="bg-[#138091] text-white text-center py-2 rounded-md font-medium no-underline hover:bg-[#3ab0bb] transition-colors replica-font" onClick={toggleMenu} data-id="element-1505">
                  Start Now
                </a>
              </div>
            </div>
          </div>}
      </header>
      {/* Hero Section with Replica Font */}
      <section className="w-full bg-[#f0f7f8] py-16 md:py-24" data-id="element-1506">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-1507">
          <div className="flex flex-col items-center text-center max-w-3xl mx-auto" data-id="element-1508">
            <div className="inline-block bg-[#e6f3f5] text-[#108194] px-4 py-1 rounded-full text-sm font-medium mb-8 replica-font" data-id="element-1509">
              <span className="flex items-center" data-id="element-1510">
                <span className="mr-2" data-id="element-1511">🚀</span>
                Launching the future of family cyber security
              </span>
            </div>
            <h1 className="mb-6 text-5xl md:text-6xl lg:text-7xl font-bold text-[#1b2f24] leading-tight replica-font" data-id="element-1512">
              Protect your family from digital chaos
            </h1>
            <div className="mb-10 max-w-2xl mx-auto" data-id="element-1513">
              <p className="text-gray-700 text-lg replica-font" data-id="element-1514">
                Take our free digital safety assessment to see where your
                <br data-id="element-1515" />
                family's at risk and how you can fix it. No email required.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4 mb-12" data-id="element-1516">
              <a href="#" className="bg-[#108194] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 no-underline hover:bg-[#0e6d7c] replica-font" data-id="element-1517">
                <span data-id="element-1518">Start Now</span>
                <ArrowLeftIcon className="transform rotate-180" size={18} data-id="element-1519" />
              </a>
              <a href="#" className="border border-[#138091] text-[#138091] px-6 py-3 rounded-md font-medium no-underline hover:bg-[#f0f7f8] transition-colors replica-font" data-id="element-1520">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Font Information Section */}
      <section className="w-full bg-white py-16 px-6" data-id="element-1521">
        <div className="max-w-3xl mx-auto" data-id="element-1522">
          <h2 className="text-3xl font-bold mb-6 text-center replica-font" data-id="element-1523">
            About Replica Font
          </h2>
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-1524">
            <p className="mb-4 replica-font" data-id="element-1525">
              Replica is a neo-grotesque sans-serif typeface that offers a
              clean, modern aesthetic with excellent readability. It features
              balanced proportions and a neutral character that makes it
              versatile for both display and body text.
            </p>
            <p className="mb-4 replica-font" data-id="element-1526">Key characteristics:</p>
            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-1527">
              <li className="replica-font" data-id="element-1528">Clean, geometric structure</li>
              <li className="replica-font" data-id="element-1529">
                Good readability at various sizes
              </li>
              <li className="replica-font" data-id="element-1530">Modern, professional appearance</li>
              <li className="replica-font" data-id="element-1531">
                Works well for digital interfaces
              </li>
            </ul>
            <div className="pt-4 border-t border-gray-200" data-id="element-1532">
              <p className="text-sm text-gray-500 replica-font" data-id="element-1533">
                Note: This is a font test page to evaluate how Replica would
                look on the Caveo website.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}